import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { deleteChart } from '@/features/charts/api/delete-chart';
import { useToast } from '@/shared/hooks/use-toast';

export const useDeleteChartMutation = () => {
  const { toast } = useToast();
  const { t } = useTranslation('chart', { keyPrefix: 'chart_creation' });

  return useMutation({
    mutationFn: deleteChart,
    onError: (error) => {
      toast({
        title: t('errors.delete_error'),
        description: error.message,
      });
    },
  });
};
